import axios from 'axios';
import router from '../router/index';

const apiUrl = process.env.VUE_APP_BASE_URL;

let header = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.clear();
      router.push('/').catch();
    }
  }
  return Promise.reject(error);
});

const get = async function (endpoint, params = null, thereIsToken = true) {
  const headers = thereIsToken
    ? {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(localStorage.getItem('shipping-admin-token')),
      }
    : {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
  if (params) {
    return axios.get(`${apiUrl + endpoint}/${params}`, {headers});
  } else {
    return axios.get(apiUrl + endpoint, {headers});
  }
};

const post = async function (endpoint, params = null, thereIsToken = true) {
  if (thereIsToken) {
    const token = localStorage.getItem('shipping-admin-token');
    header = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  if (params) {
    return axios.post(apiUrl + endpoint, params, {headers: header});
  } else {
    return axios.post(apiUrl + endpoint, {}, {headers: header});
  }
};


export {post, get};
